/**
 * Creación de pedidos: reserva consecutivo, cola offline y envío REST.
 */

import { initOrderState } from './orders-queue.js';

const MAX_REINTENTOS = 2;
const TIMEOUT_MS = 90000;
const DELAY_REINTENTO_MS = 2500;

function bumpAbortEnvio(win) {
	const state = os(win);
	state.envioPedidoAbortGen = (state.envioPedidoAbortGen || 0) + 1;
	return state.envioPedidoAbortGen;
}

function getAbortEnvio(win) {
	return (os(win).envioPedidoAbortGen || 0);
}

function esModoOffline(win) {
	if (typeof win.posknIsOfflineMode === 'function') {
		return win.posknIsOfflineMode();
	}
	return !win.navigator.onLine || win.posknServerReachable === false || !!win._posknOfflineOrderMode;
}

/** Ticket de facturación solo si el pedido quedó cobrado (no pending/cocina). */
function extraerDataPedido(response, xhr) {
	if (response && response.data && typeof response.data === 'object') return response.data;
	try {
		if (xhr && xhr.responseJSON && xhr.responseJSON.data && typeof xhr.responseJSON.data === 'object') {
			return xhr.responseJSON.data;
		}
	} catch (e) {
		/* ignore */
	}
	return null;
}

function respuestaPedidoYaCreado(response, xhr) {
	const data = extraerDataPedido(response, xhr);
	if (!data) return false;
	const okId = data.order_id != null || data.order_number != null;
	if (!okId) return false;
	const st = String(data.status || '')
		.toLowerCase()
		.replace(/^wc-/, '');
	if (st === 'completed' || st === 'processing' || st === 'on-hold') return true;
	const msg = String(data.message || response.data || '').toLowerCase();
	return msg.indexOf('ya facturado') !== -1 || msg.indexOf('ya existente') !== -1;
}

function estadoPermiteTicketFactura(st) {
	const s = String(st || '')
		.toLowerCase()
		.replace(/^wc-/, '');
	if (!s) return true;
	return s === 'completed' || s === 'processing' || s === 'on-hold';
}

function ajustarUiModalExitoTicket($, facturado) {
	const $title = $('#modal-exito .modal-title');
	const $msg = $('#modal-exito-mensaje');
	const $btn = $('#btn-imprimir-ticket-exito');
	if (facturado) {
		if ($title.length) $title.text('✅ ¡Pedido Creado!');
		if ($msg.length) $msg.text('Su pedido ha sido procesado exitosamente.');
		if ($btn.length) $btn.show();
	} else {
		if ($title.length) $title.text('Pedido en cola');
		if ($msg.length) {
			$msg.text(
				'El pedido quedó pendiente de subir. Todavía no está facturado; el ticket de facturación se imprime solo cuando WooCommerce registre la venta.',
			);
		}
		if ($btn.length) $btn.hide();
	}
}

function os(win) {
	return win.posknOrderState || initOrderState(win);
}

function syncFromInline(win) {
	if (typeof win.posknSyncOrderStateFromBundle === 'function') {
		win.posknSyncOrderStateFromBundle();
	}
}

function afterStateChange(win) {
	if (typeof win.posknAfterOrderStateChange === 'function') {
		win.posknAfterOrderStateChange();
	}
}

function metodoEsBs(win, metodo) {
	if (typeof win.posknMetodoEsBs === 'function') {
		return win.posknMetodoEsBs(metodo);
	}
	const m = String(metodo || '').toLowerCase();
	return m.indexOf('-bs') !== -1 || m.indexOf('_bs') !== -1;
}

function recopilarMetodosPago($, win, totalUsd, tieneCreditoFlag) {
	const metodosPago = [];
	let tieneCredito = tieneCreditoFlag;
	const tasa = win.TASA_DOLAR || 1;
	const round = typeof win.roundMoney === 'function' ? win.roundMoney : (n) => Math.round(Number(n) * 100) / 100;
	const toCents = typeof win.moneyToCents === 'function' ? win.moneyToCents : (n) => Math.round(Number(n) * 100);
	const fromCents = typeof win.moneyFromCents === 'function' ? win.moneyFromCents : (c) => (Number(c) || 0) / 100;
	const esEfectivo =
		typeof win.metodoEsEfectivo === 'function'
			? win.metodoEsEfectivo
			: (met) => {
					const m = String(met || '')
						.toLowerCase()
						.replace(/[_\s]/g, '-');
					return m.indexOf('efectivo') !== -1 || m === 'cash';
				};
	let pagadoEquivCents = 0;
	const bsAUsdC =
		typeof win.posknBsAUsdCents === 'function'
			? (monto) => win.posknBsAUsdCents(monto, tasa)
			: (monto) => Math.round(toCents(monto) / (tasa || 1));

	$('.payment-method.selected').each(function () {
		const $row = $(this);
		const metodo = ($row.attr('data-method') || $row.data('method') || '').toString();
		const rawMonto = $row.find('.payment-amount-input input.payment-amount-field, .payment-amount-input input[type="number"]').val();
		const parsed =
			typeof win.posknParseMontoInput === 'function'
				? win.posknParseMontoInput(rawMonto)
				: parseFloat(String(rawMonto || '').replace(',', '.')) || 0;
		let monto = round(parsed);
		const referencia = ($row.find('.payment-ref-input').val() || '').trim();
		const currencyAttr = String($row.attr('data-currency') || $row.data('currency') || '').toUpperCase();
		const esBs = currencyAttr === 'BS' || metodoEsBs(win, metodo);

		if (metodo === 'credito') {
			tieneCredito = true;
			const pagoObj = { metodo, monto, moneda: 'USD' };
			if (referencia) pagoObj.referencia = referencia;
			metodosPago.push(pagoObj);
		} else if (monto > 0) {
			const pagoObj = { metodo, monto, moneda: esBs ? 'BS' : 'USD' };
			if (referencia) pagoObj.referencia = referencia;
			metodosPago.push(pagoObj);
			pagadoEquivCents += esBs ? bsAUsdC(monto) : toCents(monto);
		}
	});

	if (tieneCredito) {
		const restanteCredito = Math.max(0, toCents(totalUsd) - pagadoEquivCents);
		metodosPago.forEach((p) => {
			if (p.metodo === 'credito' && (!p.monto || p.monto <= 0)) {
				p.monto = fromCents(restanteCredito);
			}
		});
	}

	const vueltoActivo = $('#vuelto-ajuste-activo').prop('checked');
	const hayVueltoSinAjustar =
		(typeof win._ultimoRestanteUsd !== 'undefined' && win._ultimoRestanteUsd < -0.01) ||
		(typeof win._ultimoRestanteBs !== 'undefined' && win._ultimoRestanteBs < -0.01);

	if (hayVueltoSinAjustar && !vueltoActivo && !tieneCredito && metodosPago.length > 0) {
		let totalPagadoCents = 0;
		metodosPago.forEach((p) => {
			if (p.metodo === 'credito') return;
			const esBsLine = metodoEsBs(win, p.metodo) || String(p.moneda || '').toUpperCase() === 'BS';
			totalPagadoCents += esBsLine ? bsAUsdC(p.monto) : toCents(p.monto);
		});
		let exceso = totalPagadoCents - toCents(totalUsd);
		if (exceso > 1) {
			for (let i = 0; i < metodosPago.length && exceso > 0; i++) {
				const p = metodosPago[i];
				if (p.metodo === 'credito' || !esEfectivo(p.metodo)) continue;
				const esBsLine = String(p.moneda || '').toUpperCase() === 'BS' || metodoEsBs(win, p.metodo);
				const equivCents = esBsLine ? bsAUsdC(p.monto) : toCents(p.monto);
				const quitar = Math.min(equivCents, exceso);
				if (quitar <= 0) continue;
				if (esBsLine) {
					const bsQuitar = Math.round(quitar * tasa);
					p.monto = fromCents(Math.max(0, toCents(p.monto) - bsQuitar));
				} else {
					p.monto = fromCents(Math.max(0, toCents(p.monto) - quitar));
				}
				exceso -= quitar;
			}
		}
	}

	const valorRestar = $('#vuelto-restar-metodo').val();
	const valorSumar = $('#vuelto-sumar-metodo').val();
	const monedaVuelto = $('input[name="vuelto-moneda"]:checked').val() || 'USD';
	const vueltoUsd = monedaVuelto === 'USD' ? Math.abs(win._ultimoRestanteUsd || 0) : 0;
	const vueltoBs = monedaVuelto === 'BS' ? Math.abs(win._ultimoRestanteBs || 0) : 0;

	if (
		vueltoActivo &&
		(valorRestar || valorSumar) &&
		typeof win._ultimoRestanteUsd !== 'undefined' &&
		typeof win._ultimoRestanteBs !== 'undefined'
	) {
		if (valorRestar) {
			const partesR = String(valorRestar).split('|');
			const monedaR = (partesR[0] || 'USD').toUpperCase();
			const metodoRestar = partesR[1] || '';
			const montoRestar = round(monedaR === 'BS' ? vueltoBs : vueltoUsd);
			let restado = false;
			for (let i = 0; i < metodosPago.length; i++) {
				if (metodosPago[i].metodo === metodoRestar) {
					metodosPago[i].monto = round(Math.max(0, metodosPago[i].monto - montoRestar));
					restado = true;
					break;
				}
			}
			if (!restado) {
				metodosPago.push({ metodo: metodoRestar, monto: round(-montoRestar), moneda: monedaR });
			} else {
				const iR = metodosPago.findIndex((p) => p.metodo === metodoRestar);
				if (iR >= 0 && !metodosPago[iR].moneda) metodosPago[iR].moneda = monedaR;
			}
		}
		if (valorSumar) {
			const partesS = String(valorSumar).split('|');
			const monedaS = (partesS[0] || 'USD').toUpperCase();
			const metodoSumar = partesS[1] || '';
			const montoSumar = round(monedaS === 'BS' ? vueltoBs : vueltoUsd);
			let encontrado = false;
			for (let i = 0; i < metodosPago.length; i++) {
				if (metodosPago[i].metodo === metodoSumar) {
					metodosPago[i].monto = round(metodosPago[i].monto + montoSumar);
					encontrado = true;
					break;
				}
			}
			if (!encontrado) {
				metodosPago.push({ metodo: metodoSumar, monto: round(montoSumar), moneda: monedaS });
			} else {
				const iS = metodosPago.findIndex((p) => p.metodo === metodoSumar);
				if (iS >= 0 && !metodosPago[iS].moneda) metodosPago[iS].moneda = monedaS;
			}
		}
	}

	return { metodosPago, tieneCredito };
}

function limpiarCarrito(win) {
	if (win.carrito && Array.isArray(win.carrito)) {
		win.carrito.length = 0;
	} else {
		win.carrito = [];
	}
}

/** Copia profunda de ítems para que el ticket/historial no compartan referencias con el carrito. */
function cloneCartItems(carrito) {
	try {
		return JSON.parse(JSON.stringify(Array.isArray(carrito) ? carrito : []));
	} catch (e) {
		return (Array.isArray(carrito) ? carrito : []).map((item) =>
			item && typeof item === 'object' ? { ...item } : item,
		);
	}
}

function pedidoAbiertoSiguePendiente(p) {
	if (!p || !p.order_id) return false;
	const st = String(p.status || '')
		.toLowerCase()
		.replace(/^wc-/, '');
	if (!st) return true;
	return !['completed', 'processing', 'on-hold', 'cancelled', 'refunded', 'trash', 'failed'].includes(st);
}

/** Tras cobrar: corta vínculo con WC/mesa abierta para el siguiente pedido. */
function resetSesionTrasCobrar(win, $) {
	win.pedidoMesaAbierto = null;
	try {
		win.sessionStorage.removeItem('poskn_knia_abierto');
	} catch (eKniaRst) {
		/* ignore */
	}
	win.mesaSeleccionada = null;
	$('#mesa-badge').hide();
	$('#mesa-seleccionada-compacto').hide();
	$('#mesa-indicador-carrito').hide();
	win.clienteSeleccionado = null;
	$('#cliente-seleccionado').hide();
	$('#cliente-badge').hide();
	$('#cliente-seleccionado-compacto').hide();
	$('#cliente-buscar').val('');
	try {
		win.localStorage.removeItem('pos_borrador_pedido');
		win.localStorage.removeItem('pos_borrador_pedido_bak');
		win.localStorage.removeItem('pos_pedido_enviando');
	} catch (e) {
		/* ignore */
	}
	if (typeof win.borrarBorradorPedido === 'function') {
		win.borrarBorradorPedido();
	}
}

export function attachOrderProcessGlobals(win, $) {
	win.posknAbortarEnvioPedidoActivo = function posknAbortarEnvioPedidoActivo(msg) {
		bumpAbortEnvio(win);
		const state = os(win);
		const cid = state.clientPedidoIdEnviandoActivo;
		state.clientPedidoIdEnviandoActivo = null;
		win.procesandoPedido = false;
		afterStateChange(win);
		try {
			win.localStorage.removeItem('pos_pedido_enviando');
		} catch (e) {
			/* ignore */
		}
		if (cid && typeof win.marcarAnuladoCola === 'function') {
			/* noop — usar anular vía quitar */
		}
		if (cid && typeof win.quitarDeColaPendientesSubir === 'function') {
			win.quitarDeColaPendientesSubir(cid);
		}
		$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');
		if (msg && typeof win.mostrarNotificacion === 'function') {
			win.mostrarNotificacion(msg, 'info');
		}
	};

	win.procesarPedido = function procesarPedido() {
		syncFromInline(win);

		if (win.procesandoPedido) {
			return;
		}

		let tieneCreditoPago = false;
		$('.payment-method.selected').each(function () {
			if ($(this).data('method') === 'credito') tieneCreditoPago = true;
		});
		if (tieneCreditoPago && !win.clienteSeleccionado) {
			win.mostrarNotificacion('Para pagar a crédito debes seleccionar un cliente', 'error');
			return;
		}
		if (typeof win.requireRepartidorSiDelivery === 'function' && !win.requireRepartidorSiDelivery()) {
			return;
		}

		if (
			esModoOffline(win) &&
			typeof win.posknHasUsableCatalog === 'function' &&
			!win.posknHasUsableCatalog()
		) {
			win.mostrarNotificacion(
				'Sin catálogo para modo offline. Conecta al servidor una vez para guardar el snapshot de productos.',
				'error',
			);
			return;
		}

		const consecutivoOk =
			typeof win.consecutivoSincronizado !== 'undefined'
				? win.consecutivoSincronizado
				: os(win).consecutivoSincronizado;

		if (!consecutivoOk) {
			if (esModoOffline(win)) {
				os(win).consecutivoSincronizado = true;
				syncFromInline(win);
			} else {
				win.sincronizarConsecutivoConServidor(function () {
					syncFromInline(win);
					win.procesarPedido();
				});
				return;
			}
		}

		if (typeof win.posknValidarStockCarritoParaCobro === 'function') {
			const stockGate = win.posknValidarStockCarritoParaCobro(win.carrito || []);
			if (stockGate && stockGate.ok === false) {
				win.mostrarNotificacion(
					stockGate.message || 'Stock insuficiente en esta sucursal. El cobro no se envió a la cola.',
					'error',
				);
				return;
			}
		}

		win.procesandoPedido = true;
		if (win.posknOrderState) win.posknOrderState.procesandoPedidoDesde = Date.now();
		const carrito = win.carrito || [];
		const tasa = win.TASA_DOLAR || 1;
		const descuentoActual = win.descuentoActual || { tipo: 'porcentaje', valor: 0, activo: false };
		const tot =
			typeof win.posknTotalesDesdeCarrito === 'function'
				? win.posknTotalesDesdeCarrito()
				: null;
		const subtotalUsd = tot
			? tot.subtotalUsd
			: carrito.reduce((sum, item) => sum + item.price * item.cantidad, 0);
		const descuentoUsd = tot
			? tot.descuentoUsd
			: typeof win.calcularDescuento === 'function'
				? win.calcularDescuento(subtotalUsd)
				: 0;
		let totalUsd = tot
			? tot.totalUsd
			: subtotalUsd - descuentoUsd + (typeof win.getDeliveryFeeUsd === 'function' ? win.getDeliveryFeeUsd() : 0);
		let totalBs = tot ? tot.totalBs : totalUsd * tasa;

		$('#btn-crear-pedido').prop('disabled', true).text('Reservando número...');

		win.reservarNumeroPedidoServidor(function (numeroPedido, clientPedidoId) {
			const pagoInfo = recopilarMetodosPago($, win, totalUsd, false);
			const metodosPago = pagoInfo.metodosPago;
			const tieneCredito = pagoInfo.tieneCredito;
			const estadoPedido = tieneCredito ? 'on-hold' : 'processing';
			const mesaSeleccionada = win.mesaSeleccionada;
			let pedidoMesaAbierto = win.pedidoMesaAbierto;
			const carritoEsKnia = (carrito || []).some((it) => it && it.precioFijoKnia);
			// Recuperar Knia solo si el carrito sigue siendo ese pedido WA (no un cobro nuevo de mostrador).
			if (!(pedidoMesaAbierto && pedidoMesaAbierto.order_id) && carritoEsKnia) {
				try {
					const raw = win.sessionStorage.getItem('poskn_knia_abierto');
					if (raw) {
						const recovered = JSON.parse(raw);
						if (recovered && recovered.order_id && pedidoAbiertoSiguePendiente(recovered)) {
							pedidoMesaAbierto = recovered;
							win.pedidoMesaAbierto = recovered;
						}
					}
				} catch (eRec) {
					/* ignore */
				}
			}
			if (pedidoMesaAbierto && !pedidoAbiertoSiguePendiente(pedidoMesaAbierto)) {
				pedidoMesaAbierto = null;
				win.pedidoMesaAbierto = null;
				try {
					win.sessionStorage.removeItem('poskn_knia_abierto');
				} catch (eStale) {
					/* ignore */
				}
			}
			const modoServicio = win.modoServicioSeleccionado || 'comer';
			const pedidoCanalExterno =
				!!(pedidoMesaAbierto &&
					pedidoMesaAbierto.order_id &&
					carritoEsKnia &&
					(pedidoMesaAbierto.sin_mesa || pedidoMesaAbierto.canal === 'knia'));
			const pedidoExistenteId =
				mesaSeleccionada && pedidoMesaAbierto && pedidoMesaAbierto.order_id
					? pedidoMesaAbierto.order_id
					: pedidoCanalExterno
						? pedidoMesaAbierto.order_id
						: null;
			const cerrarCuentaExistente = !!(
				(mesaSeleccionada && pedidoMesaAbierto) ||
				pedidoCanalExterno
			);
			// Id estable al cerrar mesa/Knia: reintentos no crean otro WC.
			const clientIdEnvio = pedidoExistenteId
				? `close-${pedidoExistenteId}`
				: clientPedidoId;

			const itemsPedido = cloneCartItems(carrito);
			const pedidoCompleto = {
				numero: numeroPedido,
				client_pedido_id: clientIdEnvio,
				fecha: new Date().toLocaleString(),
				items: itemsPedido,
				cliente: win.clienteSeleccionado
					? cloneCartItems([win.clienteSeleccionado])[0]
					: null,
				mesa: mesaSeleccionada ? cloneCartItems([mesaSeleccionada])[0] : null,
				tipo_servicio: modoServicio,
				tipo_servicio_label:
					typeof win.getTipoServicioLabel === 'function' ? win.getTipoServicioLabel(modoServicio) : modoServicio,
				delivery_fee: typeof win.getDeliveryFeeUsd === 'function' ? win.getDeliveryFeeUsd() : 0,
				repartidor: typeof win.getRepartidorPedido === 'function' ? win.getRepartidorPedido() : null,
				canal:
					(pedidoMesaAbierto && pedidoMesaAbierto.canal) ||
					(pedidoCanalExterno ? 'knia' : 'pos'),
				knia_code: (pedidoMesaAbierto && pedidoMesaAbierto.knia_code) || '',
				tienda: win.posknTiendaSeleccionada,
				ejecutor:
					win.posknEjecutorFacturacion && win.posknEjecutorFacturacion.id
						? { id: win.posknEjecutorFacturacion.id, nombre: win.posknEjecutorFacturacion.nombre || '' }
						: null,
				pedido_existente: pedidoExistenteId,
				subtotal: subtotalUsd,
				descuento: {
					tipo: descuentoActual.tipo,
					valor: descuentoActual.valor,
					monto: descuentoUsd,
				},
				total: { usd: totalUsd, bs: totalBs },
				metodosPago,
				tasa,
				cerrar_cuenta: cerrarCuentaExistente,
				es_credito: tieneCredito,
				estado: estadoPedido,
				caja_id_origen:
					(win._posknCajaCache && win._posknCajaCache.data && win._posknCajaCache.data.caja_id) ||
					(win.cajaActualId ? win.cajaActualId : 0),
			};

			if (pedidoCanalExterno && !pedidoExistenteId) {
				win.mostrarNotificacion(
					'Se perdió el vínculo con el pedido WhatsApp. Vuelve a Tomar desde la cola WA.',
					'error'
				);
				win.procesandoPedido = false;
				$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');
				return;
			}

			try {
				const borrador = {
					items: itemsPedido,
					mesa: mesaSeleccionada,
					cliente: win.clienteSeleccionado,
					ejecutor:
						win.posknEjecutorFacturacion && win.posknEjecutorFacturacion.id
							? { id: win.posknEjecutorFacturacion.id, nombre: win.posknEjecutorFacturacion.nombre || '' }
							: null,
					descuento: { tipo: descuentoActual.tipo, valor: descuentoActual.valor, activo: !!descuentoActual.activo },
					numero: numeroPedido,
					fecha: new Date().toISOString(),
				};
				const rawBorrador = JSON.stringify(borrador);
				win.localStorage.setItem('pos_borrador_pedido', rawBorrador);
				win.localStorage.setItem('pos_borrador_pedido_bak', rawBorrador);
			} catch (e) {
				console.warn('No se pudo guardar borrador:', e);
			}

			try {
				win.localStorage.setItem(
					'pos_pedido_enviando',
					JSON.stringify({
						pedidoCompleto,
						numeroPedido,
						totalUsd,
						totalBs,
						client_pedido_id: clientIdEnvio,
						timestamp: Date.now(),
					})
				);
			} catch (e) {
				console.warn('No se pudo guardar pos_pedido_enviando:', e);
			}

			if (typeof win.guardarEnColaPendienteSubir === 'function') {
				const okOutbox = win.guardarEnColaPendienteSubir(
					pedidoCompleto,
					numeroPedido,
					totalUsd,
					totalBs,
					clientIdEnvio,
				);
				if (!okOutbox) {
					win.procesandoPedido = false;
					$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');
					if (typeof win.mostrarNotificacion === 'function') {
						win.mostrarNotificacion(
							'No se pudo guardar la venta en pendientes. El carrito se mantiene para que no se pierda. Reintenta el cobro.',
							'error',
						);
					}
					return;
				}
				if (typeof win.marcarColaOutboxEstado === 'function') {
					win.marcarColaOutboxEstado(clientIdEnvio, 'sending');
				}
			}
			win.clientPedidoIdEnviandoActivo = clientIdEnvio;
			os(win).clientPedidoIdEnviandoActivo = clientIdEnvio;
			afterStateChange(win);

			$('#btn-crear-pedido').prop('disabled', true).text('Creando...');
			const abortGen = bumpAbortEnvio(win);

			function envioAbortado() {
				return getAbortEnvio(win) !== abortGen;
			}

			function asegurarEnCola() {
				if (typeof win.guardarEnColaPendienteSubir === 'function') {
					return win.guardarEnColaPendienteSubir(pedidoCompleto, numeroPedido, totalUsd, totalBs, clientIdEnvio);
				}
				return false;
			}

			function ponerEnColaYLimpiar(modoOffline) {
				if (envioAbortado()) return;
				const okCola = asegurarEnCola();
				if (!okCola) {
					win.procesandoPedido = false;
					$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');
					if (typeof win.mostrarNotificacion === 'function') {
						win.mostrarNotificacion(
							'No se pudo guardar la venta en pendientes. El carrito se mantiene para que no se pierda. Reintenta el cobro.',
							'error',
						);
					}
					return;
				}
				if (typeof win.marcarColaOutboxEstado === 'function') {
					win.marcarColaOutboxEstado(clientIdEnvio, 'queued');
				}
				win.clientPedidoIdEnviandoActivo = null;
				os(win).clientPedidoIdEnviandoActivo = null;
				win._posknOfflineOrderMode = false;
				afterStateChange(win);
				try {
					win.localStorage.removeItem('pos_pedido_enviando');
				} catch (e) {}
				win.limpiarEstadoDespuesDeGuardarEnCola();
				if (typeof win.posknConsumirPedidoEsperaActivo === 'function') {
					win.posknConsumirPedidoEsperaActivo();
				}
				win.procesandoPedido = false;
				$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');

				if (modoOffline) {
					if (typeof win.posknDescontarStockDesdeItems === 'function') {
						win.posknDescontarStockDesdeItems(win.carrito || pedidoCompleto.items || []);
					}
					if (typeof win.posknSaveOfflineSnapshot === 'function') {
						win.posknSaveOfflineSnapshot();
					}
					if (typeof win.posknNotificarPedidoEnColaOffline === 'function') {
						win.posknNotificarPedidoEnColaOffline(numeroPedido);
					}
					$('#pedido-numero').text(`${numeroPedido} (cola offline)`);
					$('#pedido-total-usd').text(`$${totalUsd.toFixed(2)}`);
					$('#pedido-total-bs').text(`Bs. ${totalBs.toFixed(2)}`);
					$('#pedido-fecha').text(new Date().toLocaleString());
					ajustarUiModalExitoTicket($, false);
					win.cerrarModal('modal-pago');
					$('#modal-exito').css('display', 'flex');
					return;
				}

				win.mostrarNotificacion(
					'Pedido en pendientes de subir. Se subirá al servidor cuando haya conexión. Solo se quita al subir bien o si anulas el envío.',
					'success',
				);
			}

			function onExito(response) {
				if (envioAbortado()) return;
				const data = response && response.data;
				const isAck =
					(typeof win.posknRespuestaEsAckPedido === 'function'
						? win.posknRespuestaEsAckPedido(data)
						: !!(data && data.ack === true && (data.order_id != null || data.order_number != null))) ||
					respuestaPedidoYaCreado(response);
				if (!response || !response.success || !isAck) {
					ponerEnColaYLimpiar(false);
					return;
				}

				// Venta directa y cierre mesa/Knia: no ticket ni éxito de factura si quedó pending (cocina).
				const st = String((data && data.status) || '').toLowerCase();
				if (!estadoPermiteTicketFactura(st)) {
					confirmarSiYaFacturado(() => {
						ponerEnColaYLimpiar(false);
					});
					return;
				}

				try {
					win.localStorage.removeItem('pos_borrador_pedido');
					win.localStorage.removeItem('pos_borrador_pedido_bak');
					win.localStorage.removeItem('pos_pedido_enviando');
					win.clientPedidoIdEnviandoActivo = null;
					os(win).clientPedidoIdEnviandoActivo = null;
					afterStateChange(win);
					if (typeof win.quitarDeColaPendientesSubir === 'function') {
						win.quitarDeColaPendientesSubir(clientIdEnvio);
					}
				} catch (e) {}

				const mesaCerradaId =
					mesaSeleccionada && mesaSeleccionada.id
						? mesaSeleccionada.id
						: pedidoCompleto.mesa
							? pedidoCompleto.mesa.id
							: null;
				const historialPedidos = JSON.parse(win.localStorage.getItem('historial_pedidos') || '[]');
				if (data.pos_numero) {
					numeroPedido = data.pos_numero;
					pedidoCompleto.numero = data.pos_numero;
				}
				pedidoCompleto.wc_order_id = data.order_id;
				pedidoCompleto.wc_order_number = data.order_number;
				let ticketSnapshot = pedidoCompleto;
				try {
					ticketSnapshot = JSON.parse(JSON.stringify(pedidoCompleto));
				} catch (eSnap) {
					ticketSnapshot = pedidoCompleto;
				}
				const yaEnHistorial = historialPedidos.some(
					(p) =>
						(p.wc_order_id && p.wc_order_id == data.order_id) ||
						(p.wc_order_number && p.wc_order_number == data.order_number)
				);
				if (!yaEnHistorial) historialPedidos.push(ticketSnapshot);
				while (historialPedidos.length > 40) historialPedidos.shift();
				win.localStorage.setItem('historial_pedidos', JSON.stringify(historialPedidos));
				win._posknUltimoTicketPedido = ticketSnapshot;

				$('#pedido-numero').text(`${numeroPedido} (WC: ${data.order_number || data.order_id})`);
				$('#pedido-total-usd').text(`$${totalUsd.toFixed(2)}`);
				$('#pedido-total-bs').text(`Bs. ${totalBs.toFixed(2)}`);
				$('#pedido-fecha').text(new Date().toLocaleString());

				win.cerrarModal('modal-pago');
				ajustarUiModalExitoTicket($, true);
				$('#modal-exito').css('display', 'flex');
				let anchoTicket = win.localStorage.getItem('poskn_ancho_impresora') || '80';
				if (anchoTicket === '2') anchoTicket = '58';
				if (anchoTicket === '3') anchoTicket = '80';
				$('#ancho-impresora-ticket').val(anchoTicket);

				const msgOk =
					pedidoCompleto.canal === 'knia'
						? '¡Pedido facturado! Enviado a cocina.'
						: '¡Pedido creado en WooCommerce exitosamente!';
				if (typeof win.posknConsumirPedidoEsperaActivo === 'function') {
					win.posknConsumirPedidoEsperaActivo();
				}
				win.mostrarNotificacion(msgOk, 'success');
				if (typeof win.cargarColaKnia === 'function') {
					win.cargarColaKnia(false);
				}
				if (typeof win.posknShouldAutoPrint === 'function' && win.posknShouldAutoPrint('ticket')) {
					win.setTimeout(() => {
						if (typeof win.imprimirTicket === 'function') win.imprimirTicket();
						else if (typeof win.guardarFormatoYImprimirTicket === 'function') {
							win.guardarFormatoYImprimirTicket();
						}
					}, 600);
				}
				if (typeof win.posknRefrescarStockTrasPedido === 'function') {
					win.posknRefrescarStockTrasPedido(itemsPedido);
				} else if (typeof win.posknRefrescarStockEnVivo === 'function') {
					win.posknRefrescarStockEnVivo();
				}

				win.descuentoActual = { tipo: 'porcentaje', valor: 0, activo: false };
				$('#descuento-tipo').val('porcentaje');
				$('#descuento-valor').val('');
				$('#descuento-activo').hide();
				limpiarCarrito(win);
				resetSesionTrasCobrar(win, $);
				win.pedidoMesaAbierto = null;
				try {
					win.sessionStorage.removeItem('poskn_knia_abierto');
				} catch (eKnia) {
					/* ignore */
				}
				if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();

				if (mesaCerradaId && pedidoCompleto.cerrar_cuenta && typeof win.actualizarMesaEnMemoria === 'function') {
					win.actualizarMesaEnMemoria(mesaCerradaId, 'libre', null);
				}

				if (typeof win.seleccionarTipoServicio === 'function') win.seleccionarTipoServicio('comer');
				if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();

				if (win.posknCknCache) win.posknCknCache = {};
				if (win.productosCargados) win.productosCargados = null;
				try {
					win.localStorage.removeItem('poskn_productos_cache');
					win.localStorage.removeItem('poskn_productos_timestamp');
				} catch (e) {
					console.warn('No se pudo limpiar cache de localStorage:', e);
				}

				win.procesandoPedido = false;
				$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');

				if (typeof win.posknRefreshPedidosUi === 'function') {
					win.posknRefreshPedidosUi(false);
				}
			}

			function confirmarSiYaFacturado(siNo) {
				const api = win.POSKN && win.POSKN.api;
				if (!api || typeof api.verifyPedido !== 'function') {
					siNo();
					return;
				}
				const oidHint = parseInt(pedidoExistenteId || 0, 10) || 0;
				api
					.verifyPedido(clientIdEnvio, oidHint, 12000)
					.then((res) => {
						const d = res && res.data;
						if (d && d.encontrado && d.facturado) {
							onExito({ success: true, data: d });
							return;
						}
						siNo();
					})
					.catch(() => siNo());
			}

			function enviarPedido(intento) {
				if (envioAbortado()) {
					win.procesandoPedido = false;
					$('#btn-crear-pedido').prop('disabled', false).text('CREAR PEDIDO');
					return;
				}
				win.clientPedidoIdEnviandoActivo = clientIdEnvio;
				os(win).clientPedidoIdEnviandoActivo = clientIdEnvio;
				afterStateChange(win);

				if (esModoOffline(win)) {
					ponerEnColaYLimpiar(true);
					return;
				}

				if (intento > 0) {
					$('#btn-crear-pedido').text(`Reintentando ${intento}/${MAX_REINTENTOS}...`);
					win.mostrarNotificacion('Reintentando envío del pedido...', 'info');
				}

				const req = win.POSKN.api.createOrder(pedidoCompleto, clientIdEnvio, TIMEOUT_MS);
				$.when(req)
					.done(function (response) {
						if (envioAbortado()) return;
						const data = response && response.data;
						const isAck =
							typeof win.posknRespuestaEsAckPedido === 'function'
								? win.posknRespuestaEsAckPedido(data)
								: !!(data && data.ack === true && (data.order_id != null || data.order_number != null));
						if ((response && response.success && isAck) || respuestaPedidoYaCreado(response)) {
							onExito(
								response && response.success
									? response
									: { success: true, data: extraerDataPedido(response) || data },
							);
							return;
						}
						const msgErr = win.posknParseMensajeErrorAjax(response);
						if (!msgErr && response) {
							console.error('POS crear pedido — error lógico:', response);
						}
						if (msgErr && !win.posknErrorPedidoEsRecuperable(msgErr, response)) {
							confirmarSiYaFacturado(() => {
								win.posknAbortarEnvioPedidoPorError(msgErr, clientIdEnvio);
							});
							return;
						}
						// No reintentar errores de negocio: solo red / “retry” del servidor.
						const quiereRetry = !!(response && response.retry);
						const esRedFlag = !!(response && response._network);
						if ((quiereRetry || esRedFlag) && intento < MAX_REINTENTOS) {
							setTimeout(function () {
								enviarPedido(intento + 1);
							}, DELAY_REINTENTO_MS);
							return;
						}
						confirmarSiYaFacturado(() => ponerEnColaYLimpiar(false));
					})
					.fail(function (xhr, status) {
						if (envioAbortado()) return;
						if (respuestaPedidoYaCreado(null, xhr)) {
							onExito({ success: true, data: extraerDataPedido(null, xhr) });
							return;
						}
						const msgServidor = win.posknParseMensajeErrorAjax(xhr);
						if (!msgServidor && xhr && xhr.responseText) {
							console.error('POS crear pedido — respuesta servidor:', xhr.status, xhr.responseText.substring(0, 800));
						}
						if (msgServidor && !win.posknErrorPedidoEsRecuperable(msgServidor, xhr)) {
							confirmarSiYaFacturado(() => {
								win.posknAbortarEnvioPedidoPorError(msgServidor, clientIdEnvio);
							});
							return;
						}
						const esTimeout = status === 'timeout';
						const esRed =
							typeof win.posknEsErrorRed === 'function'
								? win.posknEsErrorRed(xhr, status)
								: !xhr || status === 'error' || status === 'abort';
						if (esRed) {
							// Tras timeout el servidor puede haber creado el pedido: confirmar antes de alarmar.
							if (esTimeout || intento >= MAX_REINTENTOS) {
								confirmarSiYaFacturado(() => ponerEnColaYLimpiar(true));
								return;
							}
							confirmarSiYaFacturado(() => {
								win.mostrarNotificacion(
									esTimeout ? 'Tiempo agotado. Reintentando una vez...' : 'Error de conexión. Reintentando...',
									'info',
								);
								setTimeout(function () {
									enviarPedido(intento + 1);
								}, DELAY_REINTENTO_MS);
							});
							return;
						}
						confirmarSiYaFacturado(() => ponerEnColaYLimpiar(true));
					});
			}

			enviarPedido(0);
		});
	};
}
